import { faComment } from "@fortawesome/free-solid-svg-icons";
import { isDefinedString } from "et3-type-guards";
import React from "react";
import i18n from "../../../../constants/i18n";
import getUserDeviceStore from "../../../../stores/user-store/device-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const DevicesForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitX, unitY } = theme;

  const deviceId = getUserDeviceStore().deviceIdInput.get();
  const disabled = !isDefinedString(deviceId);

  return (
    <React.Fragment>
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"text"}
        icon={faComment}
        label={i18n.get("DEVICE_ID")}
        placeHolder={i18n.get("DEVICE_ID")}
        value={getUserDeviceStore().deviceIdInput.get()}
        onChoose={(value: string) => {
          // used the below to remove invisibile characters
          // ex: 15611dc2cfb28306‎ & 15611dc2cfb28306
          const stringWithInvisibleCharacters = value.replace(/\u200E/g, "");
          getUserDeviceStore().deviceIdInput.set(stringWithInvisibleCharacters);
        }}
        onBlur={() => {}}
        onEnter={async () => await getUserDeviceStore().searchByDeviceId()}
        style={{
          width: 280 * unitX,
          height: 95 * unitY
        }}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={!disabled}
        onClick={async () => {
          getUserDeviceStore().searchByDeviceId();
        }}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});
export default DevicesForm;
